import {action, computed, makeObservable, observable} from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import errorToast from "../../../components/toast/ErrorToast";
import successToast from "../../../components/toast/SuccessToast";
import infoToast from "../../../components/toast/InfoToast";

export default class KamDailyReportPreviewFeature {

    constructor(application) {
        this._application = application;
        this._previews = [];
        this._selectedIndex = 0;
        this._isPreviewOpen = false;
        this._isConfirmationOpen = false;

        makeObservable(this, {
            _previews: observable,
            _selectedIndex: observable,
            _isPreviewOpen: observable,
            _isConfirmationOpen: observable,
            isPreviewOpen: computed,
            isConfirmationOpen: computed,
            selectedPreview: computed,
            selectedIndex: computed,
            recipientsCount: computed,
            customersCount: computed,
            openPreview: action,
            selectRecipientAt: action,
            closePreview: action,
            openConfirmation: action,
            cancelSending: action,
        })
    }

    get isPreviewOpen() {
        return this._isPreviewOpen;
    }

    get isConfirmationOpen() {
        return this._isConfirmationOpen;
    }

    get selectedPreview() {
        return this._previews[this._selectedIndex];
    }

    get selectedIndex() {
        return this._selectedIndex;
    }

    get recipientsCount() {
        return this._previews.length;
    }

    get customersCount() {
        return this._totalCustomersCountOf(this._previews);
    }

    _totalCustomersCountOf(reports) {
        return reports.reduce((totalCustomersCount, report) =>
            totalCustomersCount + report.blockedCustomersCount + report.atRiskCustomersCount, 0);
    }

    recipientOptions() {
        return this._previews.map((preview, previewIndex) => ({value: previewIndex, label: preview.recipientLabel}));
    }

    async openPreview() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                const previews = response.reports();
                if (previews.length === 0) {
                    infoToast('No hay clientes con deuda vencida para reportar hoy');
                    return;
                }
                this._previews = previews;
                this._selectedIndex = 0;
                this._isPreviewOpen = true;
            },
            handlesError: () => {
                errorToast('No se pudo obtener la vista previa del reporte KAM');
            }
        });
        return this._application.apiClient().getKamDailyReportPreviews(responseHandler);
    }

    selectRecipientAt(index) {
        this._selectedIndex = index;
    }

    closePreview() {
        this._isPreviewOpen = false;
    }

    openConfirmation() {
        this._isConfirmationOpen = true;
    }

    cancelSending() {
        this._isConfirmationOpen = false;
    }

    async sendReports() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                const sentReports = response.reports();
                const sentCustomersCount = this._totalCustomersCountOf(sentReports);
                this._isConfirmationOpen = false;
                this._isPreviewOpen = false;
                successToast(`Reporte enviado a ${sentReports.length} destinatarios con ${sentCustomersCount} clientes`);
            },
            handlesError: () => {
                errorToast('No se pudo enviar el reporte KAM');
            }
        });
        return this._application.apiClient().sendKamDailyReportsManually(responseHandler);
    }

}
